import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

export const AppHistory: { navigate: null | NavigateFunction; push: (to: To, options?: NavigateOptions) => void } = {
  navigate: null,
  push: (page, ...rest) => (AppHistory.navigate as NavigateFunction)(page, ...rest),
};
